import { fmtCurrency, fmtPct } from "../../lib/format";
import { ChevronRight } from "lucide-react";

export default function LocationTable({ locations, onSelect }) {
  return (
    <div className="bg-brand-surface border border-brand-border" data-testid="location-table">
      <div className="px-6 pt-6 pb-4">
        <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">Roll-up by Location</p>
        <p className="font-serif text-xl text-brand-ink mt-1">Net income contribution by workspace</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-y border-brand-border text-brand-tertiary">
              <th className="text-left font-medium uppercase tracking-[0.1em] text-[11px] px-6 py-3">Location</th>
              <th className="text-right font-medium uppercase tracking-[0.1em] text-[11px] px-4 py-3">Revenue</th>
              <th className="text-right font-medium uppercase tracking-[0.1em] text-[11px] px-4 py-3 hidden md:table-cell">Net Ordinary</th>
              <th className="text-right font-medium uppercase tracking-[0.1em] text-[11px] px-4 py-3 hidden md:table-cell">Corp Alloc.</th>
              <th className="text-right font-medium uppercase tracking-[0.1em] text-[11px] px-4 py-3">Net Income</th>
              <th className="text-right font-medium uppercase tracking-[0.1em] text-[11px] px-6 py-3 hidden lg:table-cell">Occ.</th>
              <th className="w-8"></th>
            </tr>
          </thead>
          <tbody>
            {locations.map((l) => {
              const alloc = -l.corp_expense_allocation;
              const allocStr = `${alloc >= 0 ? "+" : "-"}${fmtCurrency(Math.abs(alloc))}`;
              return (
              <tr
                key={l.location} onClick={() => !l.is_corporate && onSelect(l.location)}
                data-testid={`location-row-${l.location.replace(/\s/g, "-")}`}
                className={`border-b border-brand-border last:border-0 transition-colors duration-150 group ${l.is_corporate ? "bg-brand-hover" : "hover:bg-brand-hover cursor-pointer"}`}
              >
                <td className={`px-6 py-3.5 ${l.is_corporate ? "text-brand-muted italic" : "text-brand-ink"}`}>{l.location}</td>
                <td className="px-4 py-3.5 text-right font-mono text-brand-muted">{fmtCurrency(l.total_revenue)}</td>
                <td className="px-4 py-3.5 text-right font-mono text-brand-muted hidden md:table-cell">{fmtCurrency(l.net_ordinary_income)}</td>
                <td className={`px-4 py-3.5 text-right font-mono hidden md:table-cell ${alloc >= 0 ? "text-brand-pos" : "text-brand-neg"}`}>{allocStr}</td>
                <td className={`px-4 py-3.5 text-right font-mono font-medium ${l.net_income >= 0 ? "text-brand-pos" : "text-brand-neg"}`}>{fmtCurrency(l.net_income)}</td>
                <td className="px-6 py-3.5 text-right font-mono text-brand-muted hidden lg:table-cell">{fmtPct(l.occupancy_pct)}</td>
                <td className="pr-4 text-brand-tertiary">{!l.is_corporate && <ChevronRight className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />}</td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
